import { Token, TokenType } from ".";
import { LinePosition } from "@wittongue/editor";
export class StageDirectionToken extends Token {
  constructor(key: string, linePosition: LinePosition) {
    super(key, TokenType.STAGE_DIRECTION, linePosition);
  }
}
